<template>
  <div class="container">
      <LoadingSpinner :loading="loading"> </LoadingSpinner>

      <div class="mt-4 mb-5">
        <h3>Tripletex avdelinger</h3>

        <div v-show="!loading">
            <div v-if="locations.length === 0" class="mt-4">
              <span class="message-info">Ingen avdelinger har Tripletex aktivert. Aktiver det under Avdelinger.</span>
            </div>

            <div v-if="locations.length > 0">
                <div v-if="errorMessage" class="mt-3">
                  <span class="message-error">{{ errorMessage }}</span>
                </div>

                <div v-if="departments.length > 0" class="mt-4">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Navn</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="dept in departments" :key="dept.id">
                        <td>{{ dept.id }}</td>
                        <td>{{ dept.name }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div v-if="loaded && departments.length === 0" class="mt-3">
                  <span class="message-info">Ingen avdelinger funnet i Tripletex.</span>
                </div>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
  import LoadingSpinner from "@/components/other/LoadingSpinner";
  import SettingsService from "@/services/settings/SettingsService";
  import LocationService from "@/services/location/LocationService";

  export default {
    components: {LoadingSpinner},
    data() {
      return {
        loading: true,
        locationId: '',
        locations: [],
        departments: [],
        loaded: false,
        errorMessage: ''
      };
    },
    mounted() {
      LocationService.listLocations().then(
          (response) => {
            this.locations = response.data.filter(l => l.accountingSystem === 'TRIPLETEX');
            this.locationId = this.locations.length ? this.locations[0].id : '';
            if (this.locationId) {
              this.loadDepartments();
            } else {
              this.loading = false;
            }
          },
          (error) => {
            console.log(error);
            this.loading = false;
          }
      );
    },
    methods: {
      loadDepartments(){
        this.loading = true;
        this.errorMessage = '';
        this.departments = [];
        this.loaded = false;
        SettingsService.getTripletexDepartments(this.locationId).then(
            (response) => {
              let values = response.data.values || [];
              this.departments = values;
              this.loaded = true;
              this.loading = false;
            },
            (error) => {
              this.errorMessage = 'Feil ved henting av avdelinger fra Tripletex.';
              console.log(error);
              this.loaded = true;
              this.loading = false;
            }
        );
      }
    }
  };
</script>
